import {Action} from "redux";
import {actionCreator, AppThunkAction} from "../../../state/actions";
import {IBusinessUnit} from "../../application/api/applicationModels";
import * as reduxConstants from "@/state/reduxConstants";

 
interface IBusinessUnitUnselectAllAction
    extends Action<typeof reduxConstants.BUSINESSUNIT_UNSELECT_ALL> {}

interface IBusinessUnitSelectionUpdateAction
    extends Action<typeof reduxConstants.BUSINESSUNIT_SELECTION_UPDATE> {
    selectedBusinessUnits: IBusinessUnit[];
}

interface ISurveyTabActivateAction
    extends Action<typeof reduxConstants.SURVEY_TAB_ACTIVATE> {
    isActive: boolean;
}

interface IMetricDetailTableBusinessUnitSelect
    extends Action<typeof reduxConstants.METRICDETAIL_TABLE_BUSINESSUNITS_SELECT> {
    businessUnits: IBusinessUnit[];
}

interface IMetricDetailsTableBusinessUnitUnselect
    extends Action<typeof reduxConstants.METRICDETAIL_TABLE_BUSINESSUNITS_UNSELECT> {
    businessUnits: IBusinessUnit[];
}

 
interface IMetricDetailTableBusinessUnitUnselectAll
    extends Action<
        typeof reduxConstants.METRICDETAIL_TABLE_BUSINESSUNIT_UNSELECT_ALL
    > {}

const unselectAllStores = actionCreator<IBusinessUnitUnselectAllAction>(
    reduxConstants.BUSINESSUNIT_UNSELECT_ALL
);
const updateBusinessUnitSelection =
    actionCreator<IBusinessUnitSelectionUpdateAction>(
        reduxConstants.BUSINESSUNIT_SELECTION_UPDATE
    );

const selectMetricDetailTableBusinessUnit =
    actionCreator<IMetricDetailTableBusinessUnitSelect>(
        reduxConstants.METRICDETAIL_TABLE_BUSINESSUNITS_SELECT
    );
const unselectAllMetricDetailTableBusinessUnit =
    actionCreator<IMetricDetailTableBusinessUnitUnselectAll>(
        reduxConstants.METRICDETAIL_TABLE_BUSINESSUNIT_UNSELECT_ALL
    );
const unselectMetricDetailTableBusinessUnit =
    actionCreator<IMetricDetailsTableBusinessUnitUnselect>(
        reduxConstants.METRICDETAIL_TABLE_BUSINESSUNITS_UNSELECT
    );

const surveyTabActivate = actionCreator<ISurveyTabActivateAction>(
    reduxConstants.SURVEY_TAB_ACTIVATE
);

export type MetricDetailsAction =
    | IBusinessUnitUnselectAllAction
    | IBusinessUnitSelectionUpdateAction
    | ISurveyTabActivateAction
    | IMetricDetailTableBusinessUnitSelect
    | IMetricDetailTableBusinessUnitUnselectAll
    | IMetricDetailsTableBusinessUnitUnselect;

// ----------------------------------------------------------------------------

export const actionCreators = {
    unselectAllBusinessUnits(): AppThunkAction<MetricDetailsAction> {
        return (dispatch: (action: IBusinessUnitUnselectAllAction) => void) => {
            dispatch(unselectAllStores({}));
        };
    },

    updateBusinessUnitSelection(
        selectedBusinessUnits: IBusinessUnit[]
    ): AppThunkAction<MetricDetailsAction> {
        return (dispatch: (action: IBusinessUnitSelectionUpdateAction) => void) => {
            dispatch(
                updateBusinessUnitSelection({
                    selectedBusinessUnits: selectedBusinessUnits
                })
            );
        };
    },

    surveyTabActivate(isActive: boolean): AppThunkAction<MetricDetailsAction> {
        return (dispatch: (action: ISurveyTabActivateAction) => void) => {
            dispatch(surveyTabActivate({isActive: isActive}));
        };
    },

    selectMetricDetailTableBusinessUnit(
        businessUnits: IBusinessUnit[]
    ): AppThunkAction<MetricDetailsAction> {
        return (
            dispatch: (action: IMetricDetailTableBusinessUnitSelect) => void
        ) => {
            dispatch(
                selectMetricDetailTableBusinessUnit({
                    businessUnits: businessUnits
                })
            );
        };
    },

    unselectAllMetricDetailTableBusinessUnits(): AppThunkAction<MetricDetailsAction> {
        return (
            dispatch: (action: IMetricDetailTableBusinessUnitUnselectAll) => void
        ) => {
            dispatch(unselectAllMetricDetailTableBusinessUnit({}));
        };
    },

    unselectMetricDetailTableBusinessUnit(
        businessUnits: IBusinessUnit[]
    ): AppThunkAction<MetricDetailsAction> {
        return (
            dispatch: (action: IMetricDetailsTableBusinessUnitUnselect) => void
        ) => {
            dispatch(
                unselectMetricDetailTableBusinessUnit({
                    businessUnits: businessUnits
                })
            );
        };
    }
};
